/*
 * Generates the filters to be used for the app. The main difference to the old STV app
 * is that each filter has been given it's own endpoint property to be used when calling the api.
 */
import React from "react";
import { ItemFilter, TicketFiltersProps } from "../helpers/interfaceHelper";
import ItemFilters from "./ItemFilters";

const ticketFilters: ItemFilter[] = [
  {
    property: "group_name",
    name: "Assigned Group",
    disabled: (disabledFilters) => disabledFilters.includes("group_name"),
    endpoint: "AssignedGroups",
  },
  {
    property: "status_name",
    name: "Status",
    disabled: (disabledFilters) => disabledFilters.includes("status_name"),
    endpoint: "Statuses",
  },
  {
    property: "client_name",
    name: "Companies",
    disabled: (disabledFilters) => disabledFilters.includes("client_name"),
    endpoint: "Clients",
  },
  {
    property: "client_name_not_in",
    name: "Exclude Companies",
    disabled: (disabledFilters) =>
      disabledFilters.includes("client_name_not_in"),
    endpoint: "Clients",
  },
  {
    property: "agent_name",
    name: "Agent",
    disabled: (disabledFilters) => disabledFilters.includes("agent_name"),
    endpoint: "Agents",
  },
  {
    property: "type_name",
    name: "Ticket Type",
    endpoint: "Types",
  },
  {
    property: "category",
    name: "Category",
    endpoint: "Categories",
  },
  {
    property: "sub_category",
    name: "Sub Category",
    endpoint: "Categories?categoryType=sub",
  },
  {
    property: "item_category",
    name: "Item Category",
    endpoint: "Categories?categoryType=item",
  },
];

const labelFilters: ItemFilter[] = [
  {
    property: "team_label",
    name: "Team Label",
    endpoint: "TeamLabels",
  },
  {
    property: "exclude_team_label",
    name: "Exclude Team Label",
    endpoint: "TeamLabels",
  },
];

const TicketsFilters: React.FC<TicketFiltersProps> = ({
  setFilter,
  resetFilter,
  dbViews,
  view,
  setView,
  setDefaultView,
  search,
  setSearch,
  query,
  labelsEnabled,
}) => (
  <ItemFilters
    setFilter={setFilter}
    resetFilter={resetFilter}
    dbViews={dbViews}
    view={view}
    setView={setView}
    setDefaultView={setDefaultView}
    search={search}
    setSearch={setSearch}
    query={query}
    filterList={
      labelsEnabled ? [...ticketFilters, ...labelFilters] : ticketFilters
    }
  />
);

export default TicketsFilters;
